import React, { useState } from "react";
import Button from "../../UI/Button";
import { authFetch } from "../../api/api";

const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;

export default function UploadPhotoModal({ orderId, onClose, onSuccess }) {
  const [file, setFile] = useState(null);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  const handleUpload = async () => {
    if (!file) return;

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("image", file);
      formData.append("comment", comment);

      const res = await authFetch(
        `${BASE_URL}/api/orders/${orderId}/photos/`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!res.ok) {
        const err = await res.json();
        console.error(err);
        return;
      }

      onSuccess?.();
      onClose?.();
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center">
      <div className="bg-white w-[420px] p-4 rounded space-y-3">

        <h2 className="text-lg font-bold">Загрузка фото</h2>

        <input
          type="file"
          accept="image/*"
          onChange={(e) => setFile(e.target.files[0])}
        />

        <input
          type="text"
          placeholder="Комментарий"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          className="w-full border p-2 rounded"
        />

        <div className="flex justify-end gap-2">
          <Button onClick={onClose}>Отмена</Button>

          <Button onClick={handleUpload} disabled={loading}>
            {loading ? "..." : "Загрузить"}
          </Button>
        </div>

      </div>
    </div>
  );
}